<template>
  <div>
    <div class="columns is-vcentered is-gapless is-padding-right is-border-bottom has-bg-light">
      <div class="column">
        <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns ">
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="tab = 'pending'" :class="{'is-active': tab === 'pending'}">En cours ({{pendingOptions.length}})</a>
          <a class="button has-text-draft is-small is-light is-transform-none is-padding-left-small is-padding-right-small is-min-width-0"
              @click="tab = 'history'" :class="{'is-active': tab === 'history'}">Historique ({{historyOptions.length}})</a>
        </div>
      </div>
    </div>
    <table class="table is-fullwidth is-last-fixed-small is-marginless-bottom is-radius-bottom-left is-radius-bottom-right" v-if="options && options.length">
      <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>Lot</th>
          <th>Programme</th>
          <th v-if="isAdmin && isDistributeurMode">Promoteur</th>
          <th v-if="isAdmin || isManager">Vendeur</th>
          <th>Contact</th>
          <th>Date de début</th>
          <th>Date de fin</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="option in options" :key="option.pk" class="is-size-6">
          <td class="has-text-centered">
            <span class="dot tooltip" :class="option.status|dotClass" :data-tooltip="optionStatus[option.status].label"></span>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'LotVue', params: {id: option.lot.pk || option.lot}}">{{option.lot_ref}}
            </router-link>
          </td>
          <td>{{option.program_name}}</td>
          <td v-if="isAdmin && isDistributeurMode">{{option.promoteur_name}}</td>
          <td v-if="isAdmin || isManager" class="is-cell-hoverable">
            <router-link :to="{name: 'UserVue', params: {id: option.seller}}">{{option.seller_name|smallName}}</router-link>
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'ContactVue', params: {id: option.buyer}}">{{option.buyer_name|smallName}}</router-link>
          </td>
          <td>{{ option.start_date | prettyDatetime }}</td>
          <td>{{ option.end_date | prettyDatetime }}</td>
          <td class="has-text-centered actions">
              <display-button-list :forceDropDown="true" :buttons="optionButtonList" :data="option"
                                  ></display-button-list>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="column" v-else>Aucune option à afficher</div>
  </div>
</template>

<script>
  import { OptionStatus, DefaultValues } from '@/mixins'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'UserOptionsList',
    mixins: [OptionStatus, DefaultValues],
    data () {
      return {
        loading: false,
        authorOption: [],
        tab: 'pending',
        optionButtonList: [
          {
            action: (id, option) => {
              this.$store.commit('setQuickview', {mode: 'OPTION_UPDATE_DATE', params: {source: option}})
            },
            icon: 'fa-clock',
            text: 'Modifier date de fin',
            needProfile: ['admin'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              this.$router.push({name: 'ResaCreate', params: {id}})
            },
            icon: 'fa-handshake',
            text: 'Passer en réservation',
            needProfile: ['admin'],
            display: (o) => {
              return this.canUpgrade(o.status)
            }
          },
          {
            action: (id) => {
              this.$api.optionService.patch(id, {status: 'approved'}).then(r => {
                this.updateOption(id, r.data, {
                  text: 'L\'option a été acceptée.', type: 'is-success'
                })
              })
            },
            icon: 'fa-check',
            text: 'Accepter',
            needProfile: ['admin'],
            display: (o) => {
              return this.canApprove(o.status)
            }
          },
          {
            action: (id) => {
              this.confirmDelete().then(r => {
                if (r.value) {
                  this.$api.optionService.patch(id, {status: 'refused'}).then(r => {
                    this.updateOption(id, r.data, {text: 'L\'option a été refusée.', type: 'is-success'})
                  })
                }
              })
            },
            icon: 'fa-times-octagon',
            needProfile: ['admin'],
            text: 'Refuser',
            display: (o) => {
              return this.canRefuse(o.status)
            }
          },
          {
            action: (id) => {
              this.deleteOption(id)
            },
            icon: 'fa-trash',
            text: 'Annuler',
            display: (o) => {
              return this.canCancel(o.status)
            }
          },
          {
            action: (id) => {
              this.deleteOption(id)
            },
            icon: 'fa-trash',
            needProfile: ['admin'],
            text: 'Annuler',
            display: (o) => {
              return false
            }
          }
        ]
      }
    },
    props: {
      sourceOptions: {
        type: Array,
        required: true,
        default: []
      },
      sourceAuthorOptions: {
        type: Array,
        required: true,
        default: []
      }
    },
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isAdmin', 'isManager', 'isDistributeurMode']),
      options () {
        if (this.tab === 'history') {
          return this.historyOptions
        } else {
          return this.pendingOptions
        }
      },
      historyOptions () {
        let status = ['refused', 'expired', 'sold', 'canceled_by_admin', 'canceled_by_seller']
        if (this.sourceAuthorOptions && this.sourceAuthorOptions.length) {
          let allOptions = []
          let author = this.sourceAuthorOptions.filter(x => status.includes(x.status))
          author.forEach(element => {
            allOptions.push(element)
          })
          let seller = this.sourceOptions.filter(x => status.includes(x.status))
          seller.forEach(element => {
            allOptions.push(element)
          })
          return allOptions
        }
        return this.sourceOptions.filter(x => status.includes(x.status))
      },
      pendingOptions () {
        let status = ['pending', 'waiting_list', 'approved', 'reserved']
        if (this.sourceAuthorOptions && this.sourceAuthorOptions.length) {
          let allOptions = []
          let author = this.sourceAuthorOptions.filter(x => status.includes(x.status))
          author.forEach(element => {
            allOptions.push(element)
          })
          let seller = this.sourceOptions.filter(x => status.includes(x.status))
          seller.forEach(element => {
            allOptions.push(element)
          })
          return allOptions
        }
        return this.sourceOptions.filter(x => status.includes(x.status))
      }
    },
    watch: {
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'OPTION_UPDATE_DATE') {
            this.changeOptionEndDate(results)
          }
        }
      }
    },
    methods: {
      updateOption (id, option, {text, type}) {
        if (!text) {
          text = 'L\'option a été mise à jour.'
        }
        if (!type) {
          type = 'is-success'
        }
        this.$emit('updateOption')
        this.$notify({
          type,
          text
        })
      },
      deleteOption (id) {
        this.confirmDelete().then(r => {
          if (r.value) {
            this.$api.optionService.delete(id).then(r => {
              this.$emit('updateOption')
              this.$notify({
                type: 'is-success',
                text: `Option supprimée`
              })
            }).catch(r => {
              this.$notify({
                type: 'is-danger',
                text: 'Impossible de supprimer l\'option.'
              })
            })
          }
        })
      },
      confirmDelete () {
        return this.$swal({
          title: 'Annulation',
          text: 'Êtes vous sûr de vouloir annuler cette option ?',
          confirmButtonText: 'Confirmer'
        })
      },
      changeOptionEndDate (data) {
        this.$api.optionService.patch(data.option.pk, {end_date: data.date}).then(r => {
          let notif = {
            type: 'is-success',
            text: 'La date de fin de l\'option à été mise à jour.'
          }
          this.updateOption(null, null, notif)
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Impossible de mettre à jour la date de fin de l\'option.'
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/UserVuePanel/UserOptionsList.vue